import { useState } from 'react';

import { Button, Form, Input, Modal } from 'antd';
import { useMediaActionContext } from 'components/SendItems/AddMediaContent/Context/MediaActioncontext';
import MediaContentForm from 'components/SendItems/AddMediaContent/MediaContent/MediaContentForm';
import { MEDIA_MODAL_PROPS, MEDIA_OFFER_VALIDATE_FIELDS } from 'components/SendItems/AddMediaContent/helpers';
import { PlusOutlined } from '@ant-design/icons';

const { TextArea } = Input;

function SupervisorAddMediaContent() {
  const { func } = useMediaActionContext();
  const [form] = Form.useForm();
  const [openModal, setOpenModal] = useState(false);

  const handleSave = () => {
    form.validateFields(MEDIA_OFFER_VALIDATE_FIELDS).then(() => {
      const values = form.getFieldsValue();
      func.handleSave(values);
      form.resetFields();
      setOpenModal(false);
    });
  };

  const handleCancel = () => {
    form.resetFields();
    setOpenModal(false);
  };
  return (
    <>
      <Button
        className="gx-mb-0"
        icon={<PlusOutlined />}
        type="primary"
        onClick={(e) => {
          // Modal açılırken buton focus'u koruyup aria-hidden a11y uyarısı vermesin
          e.currentTarget.blur();
          setOpenModal(true);
        }}
      >
        Medya Ekle
      </Button>
      <Modal
        {...MEDIA_MODAL_PROPS}
        title="Medya Ekle"
        open={openModal}
        onOk={handleSave}
        onCancel={handleCancel}
      >
        <Form
          form={form}
          layout="vertical"
        >
          <MediaContentForm />
          <Form.Item
            name="note"
            label="Heyet Notu"
          >
            <TextArea
              rows={7}
              placeholder="Heyet notunu buraya girebilirsiniz..."
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
export default SupervisorAddMediaContent;
